import { createContext } from 'react'

const Level = createContext(2)

export default Level
